<ng-template #content>
  <mat-toolbar *ngIf="isOpen$ | async" [color]="color" @toggle (@toggle.done)="onAnimationDone($event)">
    <div class="z-fx-grow">
      <ng-content></ng-content>
    </div>
  </mat-toolbar>
</ng-template>
